import { GetterTree } from 'vuex'
import { PartyRoomState } from '@/types/PartyRoom'
import RootState from '@/types/RootState'
import SongRequest from '@/types/SongRequest'

export const getters: GetterTree<PartyRoomState, RootState> = {
  partyID (state): string {
    return state.partyRoom ? state.partyRoom.partyID : ''
  },
  partyName (state): string {
    return state.partyRoom ? state.partyRoom.name : ''
  },
  firstSong (state): SongRequest | undefined {
    if (!(state.queue && state.queue[0])) return undefined
    return state.queue[0]
  },
  queue (state): Array<SongRequest> {
    if (state.queue) return state.queue
    return new Array<SongRequest>()
  },
  votesForNextSong (state): Array<string> {
    if (state.votesForNextSong) return state.votesForNextSong
    return new Array<string>()
  },
  playingPlaylist (state): boolean {
    if (state.partyRoom) return state.partyRoom.playingPlaylist
    else return false
  }
}
